import React, { memo } from 'react';

const ContactAdmin = ({ ...props }) => {
    return (
        <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M32 17.333c-6.627 0-12 5.374-12 12v9.334c0 2.213 1.787 4 4 4h4V32h-5.333v-2.667A9.326 9.326 0 0132 20a9.326 9.326 0 019.333 9.333V32H36v10.667h5.333V44H32v2.667h8c2.213 0 4-1.787 4-4V29.333c0-6.626-5.373-12-12-12z"
                fill="#A9B1B9"
            />
            <circle cx="32" cy="32" r="31" stroke="#A9B1B9" />
        </svg>
    );
};

export default memo(ContactAdmin);
